// util
import { eventBus, sensors, setOldUser, setUser } from '@/util'
import { isObject } from 'lodash'

const fmLogin = function(data) {
  try {
    data = JSON.parse(data)
  } catch (error) {
    data = {}
  }

  isObject(data) ? setUser(data) : setOldUser(data)
  // 给新版本增加是否已登录的标示位
  if ( data?.user?.id && isObject(data) ) {
    data.isLogin = true
  }
  // 神策埋点传入登userid
  sensors.getLoginSendUserId(data?.user?.id)
  eventBus.emit('USERLOGIN', data)
}

const getWebviewData = function(data='{}') {
  try {
    data = JSON.parse(data)
    data.status = 'success'
  } catch (error) {
    data = {'status': 'error'}
  }
  eventBus.emit('WEBVIEWONAPPEAR', data)
}

const getPageViewData = function(data='{}') {
  try {
    data = JSON.parse(data)
    data.status = 'success'
  } catch (error) {
    data = {'status': 'error'}
  }
  eventBus.emit('WEBVIEWONAPPEAR', data)
}

const getStatusBarHeight = function(data) {
  /* eslint-disable-next-line */
  const height = data
  const devicelRatio = window.devicePixelRatio || 1
  const statusBarHeight = Math.floor(height/devicelRatio) || 30
  window.STATUSBARHEIGHT = statusBarHeight
}
// const getWindowLocalStorage = window.localStorage

export default fmLogin

window.fmLogin = fmLogin
window.getWebviewData = getWebviewData
window.getPageViewData = getPageViewData
window.getStatusBarHeight = getStatusBarHeight


window.getWindowLocalStorage = window.localStorage